// Types
import { ToolTypeValue, ToolNameValue } from "./pagesToolbar.types";
// Constants
import { STORAGE_KEY } from "app/App.constants";

const HIDDEN_TOOLS_KEY = `${STORAGE_KEY}:hidden_tools`;
const NEW_DESIGN_KEY = `${STORAGE_KEY}:new_design`;
const FILTERS_SIDEBAR_OPEN_KEY = `${STORAGE_KEY}:filters_sidebar_open`;

const getToolKey = (toolType: ToolTypeValue) => {
  return `${HIDDEN_TOOLS_KEY}:${toolType}`;
};

// Storage tools
export const getHiddenTools = (toolType: ToolTypeValue):Partial<ToolNameValue>[] => {
  const toolKey = getToolKey(toolType);
  const tools = localStorage.getItem(toolKey);
  return tools ? JSON.parse(tools) : [];
};
export const onUpdateHiddenTools = (toolType: ToolTypeValue, newTools:Partial<ToolNameValue>[]) => {
  const toolKey = getToolKey(toolType);
  localStorage.setItem(toolKey, JSON.stringify(newTools));
};

// New design
export const getNewDesignEnabled = ():boolean => {
  const newDesign = localStorage.getItem(NEW_DESIGN_KEY);
  return newDesign ? JSON.parse(newDesign) : false;
};
export const onUpdateNewDesignEnabled = (newDesignEnabled:boolean) => {
  localStorage.setItem(NEW_DESIGN_KEY, JSON.stringify(newDesignEnabled));
};

// Sidebar open
export const getFiltersSidebarOpen = ():boolean => {
  const filtersSidebarOpen = localStorage.getItem(FILTERS_SIDEBAR_OPEN_KEY);
  return filtersSidebarOpen ? JSON.parse(filtersSidebarOpen) : false;
};
export const onUpdateFiltersSidebarOpen = (filtersSidebarOpen:boolean) => {
  localStorage.setItem(FILTERS_SIDEBAR_OPEN_KEY, JSON.stringify(filtersSidebarOpen));
};
